/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} School_Students_Errors_Leerling_Already_ExistsInputs */

const nl_school_students_errors_leerling_already_exists = /** @type {(inputs: School_Students_Errors_Leerling_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een leerling met dit leerlingnummer bestaat al.`)
};

/**

* @param {School_Students_Errors_Leerling_Already_ExistsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const school_students_errors_leerling_already_exists = /** @type {((inputs?: School_Students_Errors_Leerling_Already_ExistsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<School_Students_Errors_Leerling_Already_ExistsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_school_students_errors_leerling_already_exists(inputs)
});
export { school_students_errors_leerling_already_exists as "school.students.errors.leerling_already_exists" }